@if(latestPoll){
<div class="py-4 mb-3">
  <h1 class="text-2xl font-bold mb-3">Latest Poll</h1>

  <!-- IMAGE POLL -->
  @if(latestPoll.type === 2){
  <h4 class="mt-4 mb-2 text-lg font-medium text-gray-500 dark:text-white">{{latestPoll.title}}</h4>

  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
    <div *ngFor="let option of latestPoll?.pollOptions; let i = index" class="space-y-2">
      <img [src]="getImageSource(option)" [src]="option.imageUrl" alt="Poll Option Image"
        class="w-full h-48 object-cover rounded-xl border border-gray-100" />
      <div *ngIf="!isImageAvailable(option.imageUrl)"
        class="w-full h-48 bg-gray-200 flex items-center justify-center rounded-xl text-gray-500 text-sm dark:text-white">
        No image
      </div>
    </div>

  </div>
  <div class="mt-5">
    <button matButton="filled" class="w-full bg-gray-200 p-3 rounded-lg font-bold text-2xl"
      (click)="onNavigateToPoll(latestPoll.id)">
      See the results
    </button>
  </div>
  }

  <!-- TEXT POLL -->
  @if(latestPoll.type === 1){
  <div class="mb-6 space-y-5">
    <div>
      <h4 class="mt-4 mb-2 text-lg font-medium text-gray-500 dark:text-white">{{latestPoll.title}}</h4>
      @if(latestPoll.imageUrl){
      <div class="mt-5">
        <img [src]="getImageSource(latestPoll)" alt="Poll Option Image" class="w-full h-full object-cover rounded-xl" />
        <div *ngIf="!isImageAvailable(latestPoll.imageUrl)"
          class="w-full h-48 bg-gray-200 flex items-center justify-center rounded-xl text-gray-500 text-sm">
          No image
        </div>
      </div> }
      <div class="mt-5">
        <button matButton="filled" class="w-full bg-gray-200 p-3 rounded-lg font-bold text-2xl"
          (click)="onNavigateToPoll(latestPoll.id)">
          See the results
        </button>
      </div>
    </div>
  </div>
  }
</div>
}